const SET_ENVELOPE_ID = 'SET_ENVELOPE_ID';
const SET_WINDOW_INSTANCE = 'SET_WINDOW_INSTANCE';
const SET_REQUEST_OPEN = 'SET_REQUEST_OPEN';
const OPEN_SPECIFIC_IMAGE = 'OPEN_SPECIFIC_IMAGE';

const initialState = {
  windowInstance: null,
  envelopeId: null,
  imageViewerDln: null,
  requestOpen: false,
}

const ImageViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WINDOW_INSTANCE:
      return { ...state, windowInstance: action.windowInstance }
    case SET_ENVELOPE_ID:
      // console.log("updated envelopeID", action.envelopeId, action.imageViewerDln)
      return { ...state, envelopeId: action.envelopeId, imageViewerDln: action.imageViewerDln }
    case SET_REQUEST_OPEN:
      return { ...state, requestOpen: action.requestOpen }
    case OPEN_SPECIFIC_IMAGE:
      return { ...state, requestOpen: true, envelopeId: action.envelopeId, imageViewerDln: action.imageViewerDln }
    default:
      return state
  }
}

export default ImageViewerReducer
